import React from "react";
import LayoutsHome from "../../Components/Layouts/LayoutsHome";
import Section1 from "./Section1";
import "../../styles/HomeStyle.css";
import Section2 from "./Section2";
import Section3 from "./Section3";
import SectionAds from "./SectionAds";
import { Helmet } from "react-helmet-async";
function Home() {
  const newYear = new Date("Oct 9,2024").getTime();

  return (
    <>
      <Helmet>
        <title>
          US Martial Arts Seminars & Tournaments | Spectacular Seminars
        </title>

        <meta
          name="description"
          content="Professional martial arts seminars, tournaments and training events in the USA. Courses for instructors, schools and martial arts enthusiasts nationwide."
        />

        <meta
          name="keywords"
          content="martial arts seminars, martial arts tournaments, martial arts events USA, karate seminars, taekwondo tournaments, jiu jitsu seminars, martial arts training, martial arts workshops, MMA seminars, instructor courses, martial arts schools, self defense training, martial arts championships, USA martial arts events, spectacular seminars"
        />
      </Helmet>

      <LayoutsHome>
        <Section1 />
        <Section2 />
        <SectionAds />
        <Section3 newYear={newYear} />
      </LayoutsHome>
    </>
  );
}
export default Home;
